// Десктоп: наведение на карточку или на номер в иллюстрации подсвечивает карточку и меняет картинку
export default function enterpriseChecks() {
  const desktop = window.matchMedia('(min-width: 769px) and (hover: hover)');

  document.querySelectorAll('[data-checks]').forEach((root) => {
    if (root.classList.contains('enterprise-checks--builder')) {
      const desktopLayout = window.matchMedia('(min-width: 769px)');
      const cards = [...root.querySelectorAll('[data-check-card]')];
      const visuals = root.querySelectorAll('[data-check-desktop-visual]');
      const select = (key) => {
        cards.forEach((card) => {
          const selected = card.dataset.checkCard === key;
          card.classList.toggle('is-selected', selected);
          card.querySelector('[data-check-select]').setAttribute('aria-expanded', String(selected));
        });
        visuals.forEach((visual) => visual.classList.toggle('is-active', visual.dataset.checkVisual === key));
      };
      cards.forEach((card) => {
        const button = card.querySelector('[data-check-select]');
        button.addEventListener('click', () => select(card.dataset.checkCard));
        button.addEventListener('focus', () => { if (desktopLayout.matches) select(card.dataset.checkCard); });
        card.addEventListener('mouseenter', () => { if (desktopLayout.matches) select(card.dataset.checkCard); });
      });
      root.querySelectorAll('[data-check-hotspot]').forEach((hotspot) => {
        hotspot.addEventListener('mouseenter', () => { if (desktopLayout.matches) select(hotspot.dataset.checkHotspot); });
      });
      if (cards.length) select(cards[0].dataset.checkCard);
      return;
    }

    const targets = root.querySelectorAll('[data-check-card], [data-check-hotspot]');
    const desktopVisuals = root.querySelectorAll('[data-check-desktop-visual]');

    const setActive = (value) => {
      const activeKey = value && desktop.matches ? value : null;
      if (activeKey) root.dataset.active = activeKey;
      else delete root.dataset.active;

      desktopVisuals.forEach((visual) => {
        const isIdle = visual.hasAttribute('data-check-visual-idle');
        visual.classList.toggle('is-active', activeKey
          ? visual.dataset.checkVisual === activeKey
          : isIdle);
      });
      targets.forEach((target) => {
        const targetKey = target.dataset.checkKey || target.dataset.checkCard || target.dataset.checkHotspot;
        target.classList.toggle('is-hovered', targetKey === activeKey);
        target.classList.toggle('is-dimmed', Boolean(activeKey) && targetKey !== activeKey);
      });
    };

    targets.forEach((target) => {
      const value = target.dataset.checkKey || target.dataset.checkCard || target.dataset.checkHotspot;
      target.addEventListener('mouseenter', () => setActive(value));
      target.addEventListener('mouseleave', () => setActive(null));
    });

    setActive(null);
    desktop.addEventListener('change', () => setActive(null));
  });
}
